import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useGetOrganisationSubscriptionQuery } from '../services/nestjs-base-api';
import { Utils } from '../utils/utils';

// SYR-109. An org created while neither the Free tier nor the trial was on
// offer carries metadata.pendingPaidPlan on its subscription until its first
// checkout, and until then the dashboard is a plan-choice screen, not a
// product. This is a UX gate backed by entitlements, not a security boundary:
// someone who works around it holds an unadvertised Free org, which is what a
// lapsed org is anyway. Renders normally while the subscription loads so the
// common case (nothing pending) pays no wait.
export const PendingPaidPlanGate: React.FC = () => {
    const { user } = useAuth();

    const orgId = user?.organisation?.id?.toString();
    // Platform admins and agency users are never the ones being asked to pay
    // for this org, and agency portal users cannot read the endpoint at all.
    const exempt = Utils.userIsPlatformAdmin(user) || Utils.userIsAgencyUser(user);

    const { data: subscription } = useGetOrganisationSubscriptionQuery(
        { jwtToken: user?.jwtToken || '', orgId: orgId || '' },
        { skip: !user?.jwtToken || !orgId || exempt },
    );

    if (subscription?.metadata?.pendingPaidPlan === true) {
        return <Navigate to="/dashboard/choose-plan" replace />;
    }

    return <Outlet />;
};
